module.exports = __webpack_public_path__ + "static/scrape.d8608c8f.png";